export const maskContainsBit = (mask: number, bit: number): boolean => {
  return (mask & bit) === bit;
};
